// core/data/creators.ts — the shared six seeded creator accounts Videos and
// Live both reuse (core/data/users.ts / backend seed.py AUTHORS), so Follow
// genuinely works through the real useFollow -> followsService path with zero
// new backend records. Introduced in slice-4-xl's Live fix round (S4):
// seedVideoCreators and seedLiveCreators were byte-identical duplicates of
// this array — core/data/videos.ts and core/data/live.ts now both re-export
// this one array under their existing names, so nothing importing
// `seedVideoCreators`/`seedLiveCreators` needs to change.
//
// PORTED to mobile/src/core/data/creators.ts. Keep both in sync.

import type { Creator } from '@/core/models/creator';

export const seedCreators: Creator[] = [
  { id: 'freedom-seeker', name: 'FreedomSeeker', handle: '@FreedomSeeker', av: 'av-1', verified: true, followerCount: 24_800 },
  { id: 'liberty-mind',   name: 'LibertyMind',   handle: '@LibertyMind',   av: 'av-2', verified: true, followerCount: 18_300 },
  { id: 'open-mind',      name: 'OpenMind',      handle: '@OpenMindX',     av: 'av-3', verified: true, followerCount: 12_600 },
  { id: 'maya-patel',     name: 'Maya Patel',    handle: '@mayap',         av: 'av-2', verified: false, followerCount: 8_400 },
  { id: 'jordan-lee',     name: 'Jordan Lee',    handle: '@jlee',          av: 'av-4', verified: true, followerCount: 15_100 },
  { id: 'sara-kim',       name: 'Sara Kim',      handle: '@sarak',         av: 'av-5', verified: false, followerCount: 6_200 },
];
